module.exports = __webpack_public_path__ + "img/XP.0691f526.svg";